import { logger } from '@pkg/logger';
import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import { ref } from 'vue';

// Map browser language codes to our supported locale codes
export const mapUserLanguageToLocaleCode = (userLanguage: string): LOCALE_CODE | null => {
  if (!userLanguage) return null;

  const normalized = userLanguage.toLowerCase();

  const directMatch = Object.values(LOCALE_CODE).find(localeCode => localeCode === normalized);
  if (directMatch) return directMatch;

  if (normalized === 'en') return LOCALE_CODE.EN_GB;

  const languageCode = normalized.split('-')[0];

  // Find the first locale that starts with this language code
  const languageMatch = Object.values(LOCALE_CODE).find(localeCode => 
    localeCode.startsWith(languageCode + '-') || localeCode === languageCode
  );

  return languageMatch || null;
};

export const getUserLanguage = () => {
  const userLanguage = ref<string | null>(null);
  let language = 'en-gb';
  if (process.server) {
    const event = useRequestEvent();
    const acceptLanguage = event?.node.req.headers['accept-language'] as string;
    if (acceptLanguage) {
      language = acceptLanguage;
    }
  } else {
    language = navigator?.language;
  }

  const firstMatch = mapUserLanguageToLocaleCode(language) || null;
  userLanguage.value = firstMatch;

  if(!firstMatch) {
    const languageCode = navigator?.language?.toLowerCase().substring(0, 2);
    const secondMatch = Object.values(LOCALE_CODE).find(localeCode => localeCode.startsWith(languageCode));
    userLanguage.value = secondMatch || null;
  }
  return userLanguage.value;
};